import { useConditional } from "../../core/hooks/useConditional";
import { Modal } from "../../core/ui/Modal";
import { Table } from "../../core/ui/Table";
import { first } from "../../core/utils/array";
import { DateCol } from "../../layout/TableCells";
import { Name } from "../../types";
import { AddressCol } from "./Address";
import { EditTrackedItem } from "./EditTrackedItem";
import { formatData } from "./Format";
import { HistoryModal } from "./HistoryModal";
import { TrackedItemDisplay } from "./TrackedItemDisplay";
import { parseTrackedItems } from "./parseTrackedItem";



function IndividualNameDisplay(props: {
	name: Name,
	large?: boolean,
}) {

	const { name } = props;

	const format = name ? {
		lines: [
			{
				parts: [name.title, name.given1, name.given2, name.given3, name.family],
				separator: " ",
			}
		]		
	} : undefined;

	let result = formatData(format);
	if (props.large) result = <h3>{result}</h3>

	return result;
}

export function IndividualNameCol(props?: {
	title?: string,
}) {
	return {
		title: (c: any) => {
			return ((props && props.title) ? props.title : "Name");
		},
		
		value: (r: any, c: any) => {
			const name = ((r && r.name) ? r.name : r) as Name;		
			return <IndividualNameDisplay name={name} />;
		}	
	};
}

export function IndividualName(props: {
	names: Name[],
	large?: boolean,
}) {

	const names = parseTrackedItems(props.names);
	const name = first(names.active);

	const display = name ? [name.title, name.given1, name.given2, name.given3, name.family].join(" ") : "";

	const edit = useConditional(() => {
		return (
			<EditTrackedItem
				title="Edit Name"

				arr={props.names}
				initialValues={name}

				canHaveOnlyOneActive={true}

				form="name"
				formOptions={{
					showEffective: true,
				}}

				onCancel={edit.close}
				onClose={edit.close}
			/>
		)
	});

	const history = useConditional(() => {
		return (
			<HistoryModal
				title="Name History"
				onClose={history.close}
				items={props.names}
				cols={[
					IndividualNameCol(),
				]}
			/>
		);
	})

	return (
		<TrackedItemDisplay
			title="Name"
			item={name}
			edit={edit}
			history={history}
		>
			<IndividualNameDisplay name={name} large={props.large} />
		</TrackedItemDisplay>		
	)
}